/**
 * @author 133987
 */
var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.View.header = function (htOptions) {
    $.extend(this, htOptions || {});
    this.init();
};

ssg.View.header.prototype = $.extend({
    _welHeader : null,
    _welGnbArea : null,
    _welLeftBtn : null,
    _welRightBtn : null,
    init: function () {
        this._assignElements();
        this._attachEventHandlers();
    },
    _assignElements: function () {
        this._welHeader = $('#header');
        this._welGnbArea = $('#m_gnb');
        this._welLeftBtn = $('#_btn_menu');
        this._welRightBtn = $('#_btn_mall');
    },
    _attachEventHandlers: function () {
        this._welLeftBtn.length && this._welLeftBtn.on('click', $.proxy(this._onClickLeftBtn, this));
        this._welRightBtn.length && this._welRightBtn.on('click', $.proxy(this._onClickRightBtn, this));
    },
    _onClickLeftBtn: function () {
        this.emit('header.clickMenu');
    },
    _onClickRightBtn: function () {
        this.emit('header.clickMall');
    }
}, ssg.Event.emitter);